<template>
  <page-template pageTitle="Văn bản đến chờ xử lý">
    <template #headerExtend>
      <filter-by-status-header
        ref="headerFilter"
        :filterStatus="filterStatus"
        :filterOptions="filterOptions"
        :title="'Văn bản đến chờ xử lý'"
        @filterByStatus="filterByStatus"
      />
    </template>

    <!-- Start Filter data -->
    <template #filter>
      <div class="leftSection flex-row">
        <el-button
          size="medium"
          type="primary"
          class="btn___confirm"
          @click="chuyenXuLyNhieuVBan()"
          v-show="countVbanChecked > 0"
        >
          <div class="flex-row flex__center">
            <i class="fal fa-mail-bulk font-size__medium color__white"></i>
            &nbsp;&nbsp;
            <span>CHUYỂN XỬ LÝ </span>
          </div>
        </el-button>
        <el-button
          size="medium"
          type="success"
          class="btn___confirm"
          @click="ketThucNhieuVBan()"
          v-show="countVbanChecked > 0"
        >
          <div class="flex-row flex__center">
            <i class="fal fa-check-circle font-size__medium color__white"></i>
            &nbsp;&nbsp;
            <span>KẾT THÚC</span>
          </div>
        </el-button>
      </div>
      <searchTemplate
        :keyword="keyword"
        @simpleSearch="simpleSearch"
        @search="isOpenAdvanceSearchDialog = true"
      >
        <template #quickFilter>
          <div
            class="flex-row flex-left__top margin-right-10 custom-label__input"
            style="margin-top: 0px"
          >
            <span style="margin-top: 0px" class="label-input width__auto"
              >VB trong hệ thống
            </span>
            <el-checkbox
              class="
                style-fullWidth
                input-border__bottom input-border__radius__0
                bg__transparent
              "
              v-model="inPublisher"
              @change="filterByTypePublisher"
            ></el-checkbox>
          </div>
          <div
            class="flex-row flex-left__top margin-right-10 custom-label__input"
            style="margin-top: 0px"
          >
            <span style="margin-top: 0px" class="label-input width__auto"
              >VB ngoài hệ thống
            </span>
            <el-checkbox
              class="
                style-fullWidth
                input-border__bottom input-border__radius__0
                bg__transparent
              "
              v-model="outPublisher"
              @change="filterByTypePublisher"
            ></el-checkbox>
          </div>
          <div
            style="height: 39px"
            class="
              flex-row
              flex-left__top
              margin-right-10
              custom-label__input
              fix-width__large
            "
          >
            <span class="label-input width__auto">Ngày chuyển: </span>
            <el-date-picker
              v-model="sendTimeRange"
              type="daterange"
              format="dd/MM/yyyy"
              class="
                style-fullWidth
                input-border__bottom input-border__radius__0
                bg__transparent
              "
              :picker-options="dateQuickFilterOption"
              range-separator="_"
              start-placeholder="_"
              end-placeholder="_"
              align="left"
              :clearable="false"
              @change="filterBySendTime"
            ></el-date-picker>
          </div>
          <div class="margin-right-10 txt-center fix-width__small">
            <multiselect
              :class="[docReadStatusFilter ? '' : '', 'style-fullWidth']"
              :options="docReadStatusFilters"
              label="name"
              track-by="id"
              v-model="docReadStatusFilter"
              :preselect-first="true"
              placeholder="-"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="true"
              :searchable="true"
              open-direction="bottom"
              @input="filterByDocReadStatus"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div class="status-doc flex-row flex__left font-size__medium">
                  &nbsp;&nbsp;
                  <filter-icon-is-read-vban
                    :isRead="option.id"
                  ></filter-icon-is-read-vban>
                  <span>{{ option.name }}</span>
                </div>
              </template>
            </multiselect>
          </div>
        </template>
        <template #advance>
          <vbden-advance-search-dialog
            :isOpen="isOpenAdvanceSearchDialog"
            :form="advanceSearchForm"
            v-if="isEnableAdvanceSearchDialog"
            @dialogClosed="isEnableAdvanceSearchDialog = false"
            @closeDialog="isOpenAdvanceSearchDialog = false"
            @doSearch="advanceSearch"
          />
        </template>
      </searchTemplate>
    </template>
    <!-- End Filter data -->

    <!-- Start display data -->
    <template #mainContent>
      <VuePerfectScrollbar class="scroll-area" infinite-wrapper>
        <div class="barChart" ref="barChartContainerDiv">
          <el-table
            :data="incomingDocs"
            class="style-fullWidth"
            highlight-current-row
            sortable="custom"
            @sort-change="doSort"
            @row-click="viewDetail"
            :row-class-name="'item'"
            ref="mainTable"
          >
            <!-- :height="tableHeight" -->
            <el-table-column width="50">
              <template #header>
                <el-checkbox
                  v-if="hasExistChecked"
                  :class="['checkboxVBan']"
                  v-model="checkAll"
                  @change="checkAllVBan"
                ></el-checkbox>
              </template>

              <template slot-scope="{ $index, row }">
                <span class="stt" v-if="!hasExistChecked">
                  {{ $index + 1 }}
                </span>
                <div :class="['checkbox', hasExistChecked ? '' : 'hover']">
                  <el-checkbox
                    :class="['checkboxVBan']"
                    v-model="row.checkVBan"
                    @click.stop.native="() => true"
                    @change="checked"
                  ></el-checkbox>
                </div>
              </template>
            </el-table-column>

            <el-table-column width="40">
              <template slot-scope="scope">
                <is-seen-tag :isSeen="scope.row.isSeen"></is-seen-tag>
              </template>
            </el-table-column>

            <el-table-column
              property="docCode"
              label="Số ký hiệu"
              sortable
              align="left"
              :width="'110px'"
            >
              <template slot-scope="scope">
                {{ scope.row.docCode }}
              </template>
            </el-table-column>

            <el-table-column
              property="quote"
              label="Trích yếu"
              sortable
              min-width="100px"
            >
              <template slot-scope="scope">
                <a
                  class="custom-link-detail"
                  :href="convertLinkToDetail(scope.row)"
                  @click="stopProcess"
                >
                  <break-word-span
                    :text="scope.row.quote"
                    :maxLength="180"
                  ></break-word-span>
                </a>
                <!-- <span v-if="scope.row.docCode"
                  >#{{ scope.row.docCode }}&nbsp;&nbsp;</span
                > -->

                <br />

                <el-tag
                  style="margin-bottom: 3px"
                  size="medium"
                  v-if="scope.row.docTypeName"
                >
                  {{ scope.row.docTypeName }}
                </el-tag>

                <doc-priority-tag
                  style="margin-bottom: 3px"
                  :priorityName="scope.row.priorityName"
                ></doc-priority-tag>

                <doc-process-type-tag
                  style="margin-bottom: 3px"
                  :processType="scope.row.vbDocProcessType"
                ></doc-process-type-tag>

                <doc-bcc-tag
                  style="margin-bottom: 3px"
                  v-if="
                    scope.row.relationType ===
                    VB_DOC_USER.RELATION_TYPE.NGUOI_DUOC_BCC
                  "
                  :vbDocBccInfoId="scope.row.vbDocBccInfoId"
                ></doc-bcc-tag>
              </template>
            </el-table-column>

            <el-table-column
              property="docDate"
              label="Ngày văn bản"
              sortable
              align="left"
            >
              <template slot-scope="scope">
                {{
                  scope.row.docDate
                    | dateFormatter({
                      nullValue: "-",
                      dateFormat: "DD/MM/YYYY",
                    })
                }}
              </template>
            </el-table-column>

            <el-table-column
              property="senderName"
              label="Người chuyển"
              sortable
            >
              <template slot-scope="scope">
                <break-word-span
                  :text="scope.row.senderName"
                  :maxLength="100"
                ></break-word-span>
              </template>
            </el-table-column>

            <el-table-column
              property="sendTime"
              label="T/gian chuyển"
              sortable
              align="left"
            >
              <template slot-scope="scope">
                {{ scope.row.sendTime | dateFormatter({ nullValue: "-" }) }}
              </template>
            </el-table-column>

            <el-table-column
              property="deadlineDate"
              label="Hạn xử lý"
              sortable
              align="left"
            >
              <template slot-scope="scope">
                {{ scope.row.deadlineDate | dateFormatter({ nullValue: "-" }) }}
              </template>
            </el-table-column>

            <infinite-loading
              slot="append"
              ref="infiniteLoading"
              spinner="spiral"
              @infinite="infiniteHandler"
            >
              <div slot="no-more"></div>
              <div slot="no-results"></div>
            </infinite-loading>
          </el-table>
        </div>
      </VuePerfectScrollbar>

      <!-- dialog ket thuc -->
      <DocOutKetThuc
        title="Kết thúc nhiều văn bản"
        :isOpen="isOpenKetThucDialog"
        :objects="objects"
        v-if="isEnableKetThucDialog"
        @closed="isEnableKetThucDialog = false"
        @closeDialog="isOpenKetThucDialog = false"
        @success="ketThucSuccess"
      />

      <cxl-vbden-dialog
        :isOpen="isOpenTransferDialog"
        :quote="selectedDoc.quote"
        :incomingProcessId="selectedDoc.vbDocUserVbDocProcessId"
        v-if="isEnableTransferDialog"
        @closed="isEnableTransferDialog = false"
        @closeDialog="isOpenTransferDialog = false"
        @success="chuyenXuLiSuccess"
      />

      <tuChoiDialog
        :isOpen="isOpenTuChoiDialog"
        :vbIncomingDocId="userVbIncomingProcessId"
        v-if="isEnableTuChoiDialog"
        @dialogClosed="isEnableTuChoiDialog = false"
        @closeDialog="isOpenTuChoiDialog = false"
        @success="tuChoiSuccess"
      />

      <!-- chuyen xu ly nhieu van ban -->
      <transition name="el-fade-in-linear" mode="in-out">
        <ProcessChuyenXuLyNhieuVB
          :isOpen="isOpenTransferMultipleVbanDialog"
          :listIncomingDocInput="listIncomingDoc"
          v-if="
            isEnableTransferMultipleVbanDialog &&
            isOpenTransferMultipleVbanDialog
          "
          @closed="isEnableTransferMultipleVbanDialog = false"
          @closeDialog="isOpenTransferMultipleVbanDialog = false"
          @success="chuyenXuLiSuccess"
        />
      </transition>
    </template>
    <!-- End display data -->
  </page-template>
</template>
<script>
import dateFormatter from "../../filters/dateFormatter";
import constants from "../../constants";
import listTemplate from "../common/list";
import headerTemplate from "../../components/header/main-header.vue";
import vbDenMixin from "./vbDenMixin";
import utils from "../../services/utils";
import { EventBus } from "../../event-bus.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import DocOutKetThuc from "./components/DocOutKetThuc";
import CxlVbdenDialog from "./components/cxl-vbden-dialog";
import FilterByStatusHeader from "../doc-out/components/filter-by-status-header";
import QuahanTime from "../doc-out/quahan-time";
import VbdenAdvanceSearchDialog from "./components/vbden-advance-search-dialog";
import FilterIconIsReadVban from "../common/filterIconIsReadVban";
import VbProcessTypeTag from "./vb-process-type-tag";
import PageTemplate from "../common/layout/page-template";
import BreakWordSpan from "../adminstration/ketluan/break-word-span";
import DocProcessTypeTag from "./doc-process-type-tag";
import DocBccTag from "./doc-bcc-tag";
import DocPriorityTag from "../common/doc-priority-tag";
import IsSeenTag from "../common/is-seen-tag";

export default {
  components: {
    IsSeenTag,
    DocPriorityTag,
    DocBccTag,
    DocProcessTypeTag,
    BreakWordSpan,
    searchTemplate: () => import("../common/search.vue"),
    PageTemplate,
    VbProcessTypeTag,
    FilterIconIsReadVban,
    VbdenAdvanceSearchDialog,
    QuahanTime,
    FilterByStatusHeader,
    CxlVbdenDialog,
    InfiniteLoading: () => import("vue-infinite-loading"),
    DocOutKetThuc,
    listTemplate,
    headerTemplate,
    VuePerfectScrollbar,
    subHeader: () => import("../../components/main/sub-header.vue"),
    createDialog: () => import("./components/CreateDialog.vue"),
    filterByStatus: () => import("./components/filter-by-status-header.vue"),
    SortCaret: () => import("../doc-out/SortCaret"),
    tuChoiDialog: () => import("./components/tuChoiDialog"),
    ProcessChuyenXuLyNhieuVB: () =>
      import("./components/processChuyenXuLyNhieuVB"),
    displayPeople: () => import("../common/displayPeople.vue"),
  },

  filters: { dateFormatter },
  mixins: [vbDenMixin],

  data() {
    return {
      ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
      listIncomingDoc: [],
      objects: [],
      countVbanChecked: 0,
      checkAll: false,

      isOpenTransferMultipleVbanDialog: false,
      isEnableTransferMultipleVbanDialog: false,

      isOpenKetThucDialog: false,
      isEnableKetThucDialog: false,

      userVbIncomingProcessId: null,
      vbAttachment: {},
      isOpenTuChoiDialog: false,
      isEnableTuChoiDialog: false,
      isOpenTransferDialog: false,
      isEnableTransferDialog: false,
      selectedDoc: null,
      STEP_POS_TYPE: constants.STEP_POS_TYPE,
      docReadStatusFilters: [
        { id: null, name: "Tất cả" },
        {
          id: constants.READ_STATUS.UN_READ,
          name: "Chưa đọc",
        },
        {
          id: constants.READ_STATUS.READED,
          name: "Đã đọc",
        },
      ],
      filterOptions: [
        {
          value: constants.VBDEN_CHOXULY_PAGE.FILTER.ALL,
          label: "Tất cả",
          iconClass: null,
        },
        {
          value: constants.VBDEN_CHOXULY_PAGE.FILTER.CHU_TRI,
          label: "Chủ trì",
          iconClass: "fa-user",
        },
        {
          value: constants.VBDEN_CHOXULY_PAGE.FILTER.PHOI_HOP,
          label: "Phối hợp",
          iconClass: "fa-users",
        },
        {
          value: constants.VBDEN_CHOXULY_PAGE.FILTER.NHAN_DE_BIET,
          label: "Nhận để biết",
          iconClass: "fa-info",
        },
      ],
      VB_DOC_USER: constants.VB_DOC_USER,
      tableHeight: null,
      typePublisher: null,
      inPublisher: false,
      outPublisher: false,
    };
  },

  computed: {
    status() {
      return [constants.DOC_USER_STATUS.CHO_XU_LY];
    },

    currentRoute() {
      return this.$route.path.split("/")[3];
    },

    hasExistChecked() {
      return this.countVbanChecked > 0;
    },
  },

  watch: {
    isOpenTransferDialog(newValue) {
      newValue && (this.isEnableTransferDialog = newValue);
    },

    isEnableTransferDialog(newValue) {
      !newValue && (this.selectedDoc = null);
    },

    isOpenTuChoiDialog(newValue) {
      newValue && (this.isEnableTuChoiDialog = newValue);
    },

    isOpenKetThucDialog(newValue) {
      newValue && (this.isEnableKetThucDialog = newValue);
    },
    isOpenTransferMultipleVbanDialog(newValue) {
      newValue && (this.isEnableTransferMultipleVbanDialog = newValue);
    },
  },

  created() {
    this.sort = this.$route.query.sort || "sendTime";
    this.order = this.$route.query.order || "desc";
    this.initQuery();
    this.initSendTimeRange();
  },

  mounted() {
    this.tableHeight =
      window.innerHeight - this.$refs.mainTable.$el.offsetTop - 50;

    EventBus.$on(this.currentRoute, (options) => {
      this.isOpenDialogCreate = false;
      this.doSearch();
    });
  },

  methods: {
    convertLinkToDetail(item) {
      return `${window.location.origin}/#/app/${this.$store.getters.userDeptRoleId}/vbDenChoXuLy/detail/${item.id}?filterStatus=${this.$route.query.filterStatus}`;
    },

    stopProcess(e) {
      e.preventDefault();
    },

    isAutoBcc(item) {
      return (
        item.relationType === constants.VB_DOC_USER.RELATION_TYPE.NGUOI_DUOC_BCC
      );
    },

    filterByDocReadStatus(event) {
      this.advanceSearchForm.isRead = event.id === null ? undefined : event.id;
      this.doSearch();
    },

    advanceSearch(event) {
      this.advanceSearch_(event);
      this.initSendTimeRange();
      this.doSearch();
    },

    ketThucSuccess() {
      this.listIncomingDoc = this.incomingDocs = [];
      this.countVbanChecked = 0;
      this.checkAll = false;
      this.$message({
        message: "Kết thúc văn bản thành công",
        type: "success",
      });
      this.isOpenKetThucDialog = false;
    },

    checked(value) {
      this.countVbanChecked += value ? 1 : -1;
      this.checkAll = this.countVbanChecked === this.incomingDocs.length;
      let listChecked = this.incomingDocs.filter((doc) => doc.checkVBan);
      this.listIncomingDoc = this.incomingDocs.filter((doc) => doc.checkVBan);
      this.objects = listChecked.map((doc) => {
        return {
          docId: doc.docId,
          processId: doc.vbDocUserVbDocProcessId,
        };
      });
    },

    checkAllVBan(value) {
      !value && (this.countVbanChecked = 0);
      this.incomingDocs.forEach((item) => {
        if (value) {
          this.$set(item, "checkVBan", value);
          this.countVbanChecked += 1;
        } else if (!value) {
          this.$set(item, "checkVBan", value);
        }
      });
      let listChecked = this.incomingDocs.filter((doc) => doc.checkVBan);
      this.objects = listChecked.map((doc) => {
        return {
          docId: doc.docId,
          processId: doc.vbDocUserVbDocProcessId,
        };
      });
      this.listIncomingDoc = this.incomingDocs.filter((doc) => doc.checkVBan);
    },

    chuyenXuLyNhieuVBan() {
      if (this.listIncomingDoc.length === 0) {
        this.message("Thông báo", "Chưa chọn văn bản !", "warning", 2000);
        return;
      }
      this.isOpenTransferMultipleVbanDialog = true;
    },

    ketThucNhieuVBan() {
      if (this.listIncomingDoc.length === 0) {
        this.message("Thông báo", "Chưa chọn văn bản !", "warning", 2000);
        return;
      }
      this.isOpenKetThucDialog = true;
    },

    viewDetail(item) {
      item.isSeen = 1;
      let query = utils.merge(this.$route.query, {
        vbDocProcessId: item.vbDocUserVbDocProcessId,
      });
      let params = utils.merge(this.$route.params, {
        id: item.vbIncomingDocUserViewKey.id,
      });
      this.$router.push({
        name: "vbDenChoXuLyDetail",
        params: params,
        query: query,
      });
    },

    chuyenXuLy(item) {
      this.selectedDoc = item;
      this.isOpenTransferDialog = true;
    },

    chuyenXuLiSuccess(event) {
      this.listIncomingDoc = [];
      this.countVbanChecked = 0;
      this.isOpenTransferDialog = false;
      this.isOpenTransferMultipleVbanDialog = false;
      this.doSearch();
    },

    tuChoiSuccess(event) {
      this.isOpenTuChoiDialog = false;
      this.incomingDoc = event.vbIncomingDoc;
    },
  },
};
</script>
<style scoped>
#searchBox {
  position: relative;
  width: 100%;
}

.advance-search {
  font-size: 17px;
  color: #005eb1;
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
}

.icon-very__small {
  height: 14px;
  padding-top: 4px;
}

.icon-info {
  background-color: #f0c330;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-top: -1px;
  margin-left: 2px;
}

.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity 1.5s;
}

.fade-in-enter, .fade-in-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.item .checkbox.hover {
  display: none;
}

.item:hover .stt {
  display: none;
  transition: 0.5s;
}

.item:hover .checkbox.hover {
  display: flex;
  transition: 0.5s;
}

.scroll-area {
  max-height: 100% !important;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/vbDenChoXuLyIndex.vue